// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"517":"07ebe0de","901":"be413d3d"}[chunkId] + ".chunk.css";
};